import * as Yup from 'yup';
// utilities
import * as U from '../../../utilities';
// constants
import { FIELD_NAME, FIELD_TYPE_TEXT } from '../../../constants';
//////////////////////////////////////////////////

const defaultReportFields = {
  [FIELD_NAME]: '',
};

const validationSchema = () => Yup.object().shape({
  [FIELD_NAME]: Yup.string()
    .nullable(true)
    .required(U.getRequiredLocaleTxt())
    .min(3, U.getShouldBeFromToCharLocaleTxt(3, 40))
    .max(40, U.getShouldBeFromToCharLocaleTxt(3, 40)),
});

const submitBtnStyles = {
  width: 120,
  useCancelBtn: true,
};

const inputWrapperStyles = { mb: '25px', width: 490, shrink: true };

const reportFields = [
  {
    required: true,
    fieldName: FIELD_NAME,
    label: 'labels.reportName',
    fieldType: FIELD_TYPE_TEXT,
    inputStyles: inputWrapperStyles,
  },
];

export {
  reportFields,
  submitBtnStyles,
  validationSchema,
  inputWrapperStyles,
  defaultReportFields,
};
